var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2cb6bc786a50c85163c52e15d08a9d5796eb80ac"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yoco-com@yoco-technologies"]={id:"2cb6bc786a50c85163c52e15d08a9d5796eb80ac"};
      